import { Cell, FormControl, Grid, Theme, useStyles, VFlow } from 'bold-ui'
import { useAlert } from 'components/alert'
import CheckPermission from 'components/auth/CheckPermission'
import { useFlags } from 'config/useFlagsContext'
import { toDate } from 'date-fns'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { CSSProperties } from 'react'
import { dateAsYyyyMmDd } from 'util/date/formatDate'
import { MetaPath } from 'util/metaPath'

import { grupoCboCid11 } from '../acessos'
import { CiapPlanoModel, Cid11PlanoModel } from '../model-plano'
import { PlanoFormProps } from '../PlanoForm'
import { CiapPlanoField, CiapPlanoProps } from './CiapPlanoField'
import { Cid11PlanoField } from './Cid11PlanoField'
import { ProcedimentoPlanoField, ProcedimentoPlanoModel } from './ProcedimentoPlanoField'

export interface ProcedimentosPlanoModel {
  procedimentos?: ProcedimentoPlanoModel[]
  codigosProcedimentosAutomaticosExcluidos?: string[]
}
export interface IntervencoesProcedimentosPlanoModel {
  ciaps?: ReadonlyArray<CiapPlanoModel>
  cids11?: ReadonlyArray<Cid11PlanoModel>
  procedimentosPlano?: ProcedimentosPlanoModel
}

interface IntervencoesProcedimentosViewProps
  extends Omit<CiapPlanoProps, 'name'>,
    Pick<PlanoFormProps, 'isAtendimentoOdonto' | 'isAtendimentoProcedimentos'> {
  name: MetaPath<IntervencoesProcedimentosPlanoModel>
  dataAtendimento: Instant
}

export function IntervencoesProcedimentosView(props: Readonly<IntervencoesProcedimentosViewProps>) {
  const { isAtendimentoOdonto, isAtendimentoProcedimentos, cidadao, name, dataAtendimento } = props
  const { classes } = useStyles(createStyles)
  const alert = useAlert()
  const { isRetificacao } = useAtendimentoContext()
  const { CID11_MTC_ENABLED } = useFlags()

  const alertProcedimentoAutomaticoAlterado = () => {
    alert(
      'info',
      'Um procedimento automático foi alterado na lista de intervenções e/ou procedimentos clínicos realizados.'
    )
  }

  return (
    <VFlow vSpacing={0}>
      <FormControl label='Intervenções e/ou procedimentos clínicos realizados' style={classes.heading}>
        <Grid>
          {!isAtendimentoOdonto && (
            <Cell size={12}>
              <CiapPlanoField name={name.ciaps} cidadao={cidadao} controlModifiedStatus={isRetificacao} />
            </Cell>
          )}
          {CID11_MTC_ENABLED && (
            <CheckPermission permission={grupoCboCid11}>
              <Cell size={12}>
                <Cid11PlanoField name={name.cids11} controlModifiedStatus={isRetificacao} />
              </Cell>
            </CheckPermission>
          )}
          <Cell size={12}>
            <ProcedimentoPlanoField
              name={name.procedimentosPlano}
              cidadao={cidadao}
              filtrarProcedimentosOdonto={isAtendimentoOdonto}
              dataAtendimento={dateAsYyyyMmDd(toDate(dataAtendimento))}
              onAutomaticChange={alertProcedimentoAutomaticoAlterado}
              required={isAtendimentoProcedimentos}
              controlModifiedStatus={isRetificacao}
            />
          </Cell>
        </Grid>
      </FormControl>
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  heading: {
    '> label': {
      ...theme.typography.variant('h3'),
    } as CSSProperties,
  } as CSSProperties,
})
